import React, {useRef, useEffect } from "react";
import "../Styles/WebAdmin.css"
import "../Styles/TvDashboard.css"
import Navbar from "./Navbar";
import { getUserDetails, setSensorLog, setSensorOnTime, setStats } from "../Utility/AsyncStorageData";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Header from "./Header";
import Report from '../Utility/Report'
import moment from 'moment';
import 'react-loading-skeleton/dist/skeleton.css'
import MachineCardGrid from './MachineCardGrid';
import Modal from "./Modal";

var runtimeid = 0
var statueBarInterval = 19;
var intervalId = 0;

function WebAdmin() {

  var userDetails = getUserDetails();

  // console.log("**************WebAdmin*****************", userDetails)
  let navigate = useNavigate();

  const gb_machine_id = useRef("");
  const updateAnimation = useRef(false);
  const [error, setError] = React.useState('');
  const [graph, setGraph] = React.useState([]);
  // const [runningListLog, setRunningListLog] = React.useState({});
  const [runningStatus, setRunningStatus] = React.useState({});
  const [colorWidthData, setColorWidthData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [downloadExcel, setDownloadExcel] = React.useState(false);

  const receiveDataFromChild = (data) => {
    setDownloadExcel(false);
  };


  const handleFetchMachineList = async () => {
    try {
      // console.log("*********** handleFetchMachineList ***********")


      let url = process.env.REACT_APP_BASE_URL + "/sensor/getCompanyWiseSensorList";
      let body = {
        comp_num: userDetails.comp_num
      }
      // console.log("===============getCompanyWiseSensorList======================", body)

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("getCompanyWiseSensorList======================", response.data.result)

            const machineIds = response.data.result.map(item => item.machine_id);
            const machineIdsString = machineIds.map(item => `${item}`).join(', ');

            // console.log("machineIds===================", machineIdsString);

            const elements = machineIdsString.split(', ');
            gb_machine_id.current = elements.map(element => `'${element}'`).join(', ');

            //subscribeFCMTopic()

            // console.log("response.data.resultresponse.data.resultresponse.data.result", response.data.result);

            setGraph(response.data.result)

            // let temp = {};
            // let speed_temp = {};

            Runtime()

          }

          else {

            setError(response.data.msg)
            setTimeout(() => errortimer(), 2000)
            console.log("error in getCompanyWiseSensorList: ", response.data.msg);
            setIsLoading(false)
          }
          // setLoading(false);
        }

        else if (response.status === 403) {
          navigate("/");
        }

      }).catch(error => {
        console.log("error: ", error);
        if (error.response.status === 403) {
          navigate("/");
        }
        setError("ERROR")
        setTimeout(() => errortimer(), 2000)
        //         setLoading(false);
        //         return
      })
    } catch (error) {
      console.log("error ", error)
      //     setLoading(false);
      //     throw error;
    }

  }


  const Runtime = async () => {
    try {

      console.log('*********** getMachineStatus api ***********');

      if (gb_machine_id.current.length !== 0) {

        // console.log('*********** api hit ***********', d);

        let url = process.env.REACT_APP_BASE_URL + '/sensor/getMachineStatus';
        let body = {
          // machineState: machineState,
          machine_id: gb_machine_id.current
        };

        // body.machine_id = elements.map(element => `'${element}'`).join(', ');
        // console.log(" getMachineStatus body", body)
        await axios
          .post(url, body, {
            headers: {
              authorization: `${userDetails.access_token}`,
            },
          })
          .then(response => {
            if (response.status === 200) {
              if (response.data.statusCode === 0) {

                // setRunningListLog(response.data)
                // console.log("asdfghj", response.data)
                setStats(JSON.stringify(response.data))

                setRunningStatus(response.data.list)
                // console.log("statueBarInterval1", statueBarInterval, response.data)
                console.log("statueBarInterval")
                statueBarInterval = statueBarInterval + 1;
                if (statueBarInterval >= 20) {

                  statueBarInterval = 0;
                  dashProgressBar()
                }
                updateAnimation.current = false

                setIsLoading(false)
              }
              else if (response.data.statusCode === 2) {

                setIsLoading(false)
                console.log("getMachineStatus api error", response.data.msg)
              }
              else {

                console.log("getMachineStatus api error", response.data.msg)
                setError("ERROR")
                setTimeout(() => errortimer(), 2000);
              }
            }
          })
          .catch(error => {
            // Alert.alert("ERROR")
            console.log("ERROR", error)
            // if (error.response.status === 403) {
            //   navigate("/");
            // }
            setError('ERROR');
            setTimeout(() => errortimer(), 2000);
          });
        // setLoading(false);
      }
      runtimeid = setTimeout(() => Runtime(), 30000)
    } catch (error) {
      console.log('error ', error);
      runtimeid = setTimeout(() => Runtime(), 30000)
      throw error;
    }
  }

  const dashProgressBar = async () => {
    try {
      // console.log('*********** dashProgressBar api ***********');

      if (gb_machine_id.current.length !== 0) {

        let url = process.env.REACT_APP_BASE_URL + '/shift/fetchLogWiseData';
        let a = ""
        for (let key of gb_machine_id.current) {
          a = a + key.replace("'", "")
        }

        let body = {
          machine_ids: a
        };

        // console.log(" dashProgressBar body", body)
        await axios
          .post(url, body, {
            headers: {
              authorization: `${userDetails.access_token}`,
            },
          })
          .then(response => {
            if (response.status === 200) {
              if (response.data.statusCode === 0) {
                // setMachineData(response.data.list)
                // setMachineStates(response.data)
                setColorWidthData(response.data.result)
                // console.log(response.data.result)
              } else {

                console.log("dashProgressBar api error", response.data.msg)
                setError(response.data.msg)
                setTimeout(() => errortimer(), 2000);
              }
            }
            else if (response.status === 403) {
              // console.log("refreshAccessToken: ");
              // refreshAccessToken();
              dashProgressBar();
            }
          })
          .catch(error => {
            if (error.response.status === 403) {
              navigate("/");
            }
            console.log("ERROR", error)
            setError('ERROR');
            setTimeout(() => errortimer(), 2000);
          });
        // setLoading(false);
      }

    } catch (error) {
      console.log('error ', error);
      setError('ERROR');
      setTimeout(() => errortimer(), 2000);
      // statueBarInterval = setTimeout(() => dashProgressBar(), 30000)
      throw error;
    }
  }

  // const borderRadius = (serialNo, machineId) => {
  //   // console.log(serialNo, machineId ,colorWidthData[machineId].length )
  //   if (colorWidthData[machineId].length == 1) {
  //     return "10px"
  //   }
  //   else if (serialNo == colorWidthData[machineId].length - 1) {
  //     // console.log(colorWidthData[machineId])
  //     return " 0 10px 10px 0 "
  //   }
  //   else if (serialNo == 0) {
  //     return " 10px 0 0 10px"
  //   }


  // }

  const machineTime = (mech_id, data) => {
    if (runningStatus[mech_id]) {
      // console.log("machineTime" , runningStatus[mech_id].machine_current_status, data)
      if (runningStatus[mech_id].machine_current_status === "D") {
        return ("#E9E9E9") //gray
      }
      else {
        if (runningStatus[mech_id].efficiency >= data.Y) {
          return "#F1F9EE" //green
        }
        else if (runningStatus[mech_id].efficiency >= data.R) {
          return "#FEFBED" // orange
        }
        else {
          return "#FBF3F3" // red
        }
      }
    }
    else {
      return ("#D3D3D3") //gray
    }
  }

  const updateOnTimeInSec = () => {
    if (Object.keys(runningStatus).length) {
      setRunningStatus((prevData) => {
        const updatedData = { ...prevData }; // Create a shallow copy of the previous state
        for (let key of graph) {
          // console.log("key.sensor_data" , updatedData, key.machine_id)
          if (updatedData[key.machine_id].machine_current_state === '2') {
            const timeObject = new Date(
              `2000-01-01T${updatedData[key.machine_id].on_time}`
            );
            timeObject.setSeconds(timeObject.getSeconds() + 1);
            const newTimeString = timeObject.toLocaleTimeString('en-US', {
              hour12: false,
            });

            // Create a new object for the specific item and update the on_time property
            updatedData[key.machine_id] = {
              ...updatedData[key.machine_id],
              on_time: newTimeString,
            };
          }
        }
        return updatedData;
      });
    }

  }


  const machineStatus = (mech_id) => {
    if (Object.keys(runningStatus).length && runningStatus[mech_id]) {
      let color = 'gray';

      if (runningStatus[mech_id].machine_current_status === "D") {
        color = 'rgb(30, 42, 122)';
      } else if (runningStatus[mech_id].machine_current_state === "0") {
        color = 'rgb(249, 113, 113)';
      } else if (runningStatus[mech_id].machine_current_state === "1") {
        color = '#F6E069';
      } else {
        color = '#8FCD71';
      }

      return (
        <div
          className="clock"
          style={{
            // position: "absolute",
            // top: "7.5px",
            // right: "7.5px",
            // backgroundColor: color,
            // width: "15px",
            // height: "15px",
            // borderRadius: "50%",
            // zIndex: 1
            // position: "absolute",
            // top: "50%",
            // left: "50%",
            // width: "15px",
            // height: "15px",
            // backgroundColor: color,
            // borderRadius: "50%",
            // transform: "translate(-50%, -50%)",
            // zIndex: 5,
          }
          }
        >
        </div >
      );
    }
  };


  const NavigateToLogs = (item) => {
    console.log("NavigateToLogs", item)
    setSensorLog(JSON.stringify(item))

    let temp = {
      on_time: runningStatus[item.machine_id].on_time ?? 0,
      efficiency: runningStatus[item.machine_id].efficiency ?? 0,
      mcs: runningStatus[item.machine_id].machine_current_state ?? 0,
      Idproduct: runningStatus[item.machine_id].id ?? 0,
      product: runningStatus[item.machine_id].product_part,
      sensor_count: runningStatus[item.machine_id].sensor_count,
      counter_unit: runningStatus[item.machine_id].counterUnit,
      counter_flag: item.counter_flag
    }

    setSensorOnTime(JSON.stringify(temp))
    navigate("/machineLogs");

  }

  const ButtonColor = (mech_id, data) => {
    if (runningStatus[mech_id]) {
      if (runningStatus[mech_id].machine_current_status === "D") {
        return ("#1E2A7A") //gray
      }
      else {
        if (runningStatus[mech_id].efficiency >= data.Y) {
          return ("#8FCD71") //green
        }
        else if (runningStatus[mech_id].efficiency >= data.R) {
          return ("#F6E069") // orange
        }
        else {
          return ("#F97171") // red
        }
      }
    }
    else {
      return ("#D3D3D3") //gray
    }
  }


  const showShift = (machine_id) => {
    const time = moment(runningStatus[machine_id].start_time, 'HH:mm:ss')
    const start = time.format('HH:mm');


    const time1 = moment(runningStatus[machine_id].end_time, 'HH:mm:ss')
    const end = time1.format('HH:mm');

    return (start + " - " + end)

  }

  const PrevshowShift = (machine_id) => {
    const time = moment(runningStatus[machine_id].previousData.shift_start_time)
    const start = time.format('HH:mm');


    const time1 = moment(runningStatus[machine_id].previousData.shift_end_time)
    const end = time1.format('HH:mm');

    // console.log("start time - end time", start,end, time, time1)
    return (start + " - " + end)

  }


  clearInterval(intervalId);
  intervalId = setInterval(() => {
    updateOnTimeInSec();
  }, 1000);

  const errortimer = () => {
    setError(undefined)
  }


  useEffect(() => {
    handleFetchMachineList()
    return () => {
      clearInterval(runtimeid);
      clearInterval(intervalId); // Clean up the interval when the component unmounts
    };
  }, []);


  return (
    <div className='main'>

      <div>
        <Navbar />
      </div>

      <div className='Admin_menu'>
        <div className='TvDashboard'>

          <Header show={0} />
          <div style={{ display: "flex", flexDirection: "row", position: "absolute", top: 10, right: 10, }} >
            <i style={{ paddingRight : 260, paddingTop : 7, margin: "0", fontSize: 20, color: "#254e6f" }} class="fa fa-download" onClick={() => setDownloadExcel(true)}></i>
          </div>
          
          <Modal isOpen={downloadExcel}>
            <div>
              <div className='report_download'>
                <h3>Report Download</h3>
                <i className="fa-solid fa-xmark" onClick={() => setDownloadExcel(false)}></i>
              </div>
              <Report show={4} deviceData={gb_machine_id.current.replace(/'/g, '').replace(/\s/g, '')} sendDataToParent={receiveDataFromChild} email={false} />
            </div>
          </Modal>

          <div className='com_name_mobile'>
            <h3>SuperManager</h3>
          </div>

          <div className='machines1'>

            <MachineCardGrid
              graph={graph}
              runningStatus={runningStatus}
              colorWidthData={colorWidthData}
              NavigateToLogs={NavigateToLogs}
              machineTime={machineTime}
              machineStatus={machineStatus}
              showShift={showShift}
              PrevshowShift={PrevshowShift}
              ButtonColor={ButtonColor}
              machineKey="machine_id"
              updateAnimation={updateAnimation.current}
              isLoading={isLoading}
            />

            {updateAnimation.current = true}

          </div>


        </div>


        <div>
          <p className='error'>{error}</p>
        </div>
      </div>
    </div>
  )
}

export default WebAdmin